import styled from "styled-components";
import colours from "../../utils/colours";

const FieldErrors = styled.ul``;
const Error = styled.li`
  color: ${colours.lightRed};
`;

export default { FieldErrors, Error };
